import { blipDomainUrl, blipWebsocketHostName, blipWebsocketHostNameTenant, messaginghubWebsocketHostName, messaginghubWebsocketHostNameTenant, } from 'app.constants';
import { FeatureToggleClientService } from 'feature-toggle-client';
import { MessagingHubFeatures } from 'modules/messaginghub/MessagingHubFeatures';
/**
 * Base controller for analytics-related controllers (Dashboard and GoodData).
 * Provides common functionality and initialization logic to reduce code duplication.
 */
export class BaseAnalyticsController {
    static $inject = ['LoadingService', 'TranslateService', 'AccountService2', 'AuthenticationService', 'ApplicationService2', 'BuilderService'];
    constructor(LoadingService, TranslateService, AccountService2, AuthenticationService, ApplicationService2, BuilderService) {
        this.LoadingService = LoadingService;
        this.TranslateService = TranslateService;
        this.AccountService2 = AccountService2;
        this.AuthenticationService = AuthenticationService;
        this.ApplicationService2 = ApplicationService2;
        this.BuilderService = BuilderService;
        this.blipDomainUrl = blipDomainUrl;
        this.blipWebsocketHostName = messaginghubWebsocketHostNameTenant;
        this.blipWebsocketHostNameTenant = messaginghubWebsocketHostNameTenant;
        this.readyToRender = false;
        this.isAutomaticTrackingPublished = false;
        this.isMasterApplication = false;
    }
    async $onInit() {
        const useDelegation = await MessagingHubFeatures.GetMessagingHubCommandWithDelegation();
        this.featureFlags = FeatureToggleClientService.getInstance().getUserInstance().allFlags();
        this.user = await this.AccountService2.me();
        this.language = this.TranslateService.getCurrentLanguage();
        const account = await this.ApplicationService2.getAccount();
        this.botIdentity = account.identity;
        const application = await this.ApplicationService2.getApplication(this.botIdentity.split('@')[0]);
        this.isMasterApplication = this.ApplicationService2.isThisMasterApplication(application);
        this.authToken = useDelegation ? this.AuthenticationService.token : application.accessKey;
        this.blipWebsocketHostName = useDelegation ? blipWebsocketHostName : messaginghubWebsocketHostName;
        this.blipWebsocketHostNameTenant = useDelegation ? blipWebsocketHostNameTenant : messaginghubWebsocketHostNameTenant;
        try {
            this.isAutomaticTrackingPublished = await this.BuilderService.isAutomaticTrackingPublished();
        }
        catch {
            this.isAutomaticTrackingPublished = false;
        }
        this.authEmail = this.AuthenticationService.email;
        this.LoadingService.stopLoading();
        this.readyToRender = true;
    }
}
BaseAnalyticsController.$inject = ['LoadingService', 'TranslateService', 'AccountService2', 'AuthenticationService', 'ApplicationService2', 'BuilderService'];
